<template>
  <div class="backlink">
    <b-button variant="light" class="mb-2" @click="goBack">
      <i class="far fa-angle-left fa-lg"></i>
    </b-button>
  </div>
</template>

<script>
export default {
  name: "BackLink",
  methods: {
    goBack() {
      this.$router.go(-1);
    }
  }
};
</script>

<style lang="scss">
@import "~@/assets/scss/_variables.scss";

.backlink {
  float: left;
  margin-right: 10px;
  .btn {
    height: 23px;
    width: 23px;
    line-height: 23px;
    padding: 0;
    color: $text-50p;
  }
  & + h1 {
    margin-left: 33px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Global/BackLink.vue